import { render } from "./editor.vue?vue&type=template&id=7e396fcc&scoped=true&ts=true"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"

import "./editor.vue?vue&type=style&index=0&id=7e396fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e396fcc"]])

export default __exports__